import { useState, useEffect, useRef } from "react";
import { Capacitor } from "@capacitor/core";

export default function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(true);
  const removeRef = useRef(null);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      let mounted = true;
      // Dynamic import to avoid bundling on web
      import("@capacitor/network").then(({ Network }) => {
        Network.getStatus().then((s) => {
          if (mounted) setIsOnline(s.connected);
        });
        const handler = Network.addListener("networkStatusChange", (s) => {
          setIsOnline(s.connected);
        });
        handler.then((h) => {
          if (mounted) {
            removeRef.current = () => h.remove();
          } else {
            h.remove();
          }
        });
      }).catch(() => {});

      return () => {
        mounted = false;
        if (removeRef.current) removeRef.current();
      };
    } else {
      // Web fallback
      setIsOnline(navigator.onLine);
      const goOnline = () => setIsOnline(true);
      const goOffline = () => setIsOnline(false);
      window.addEventListener("online", goOnline);
      window.addEventListener("offline", goOffline);
      return () => {
        window.removeEventListener("online", goOnline);
        window.removeEventListener("offline", goOffline);
      };
    }
  }, []);

  return isOnline;
}
